import api from '../../../App/socket';

export const setCustomerName = (_id, customer_name) => (
    api.send({
        api: 'db',
        model: 'Lead_customer',
        action: 'Update',
        options: {
            update: {
                full_name: customer_name,
            },
            where: { _id },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/set_customer_name_request.js